.questionList {
  width: 100%;
  border: solid 1px var(--darkSilver);
  height: 200px;
  overflow: hidden scroll;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.questionList li {
  display: table;
  width: 100%;
  height: 2.5em;
  padding-left: 0.5em;

  &:nth-child(odd) {
    background: var(--silver);
  }

  & input {
    display: table-cell;
    vertical-align: middle;
    height: 100%;
  }

  & label {
    display: table-cell;
    vertical-align: middle;
    font-size: 1em;
    width: 100%;
    height: 100%;
  }
}
